<template>
  <div class="wrap">
    <h2>服务托管协议</h2>
    <section>
      <p style="text-align: left; margin: 10px 0">
        本版更新日期：2021年5月26日
      </p>
      <p style="margin-bottom: 10px">
        为了更便捷地享受高德黑卡商家权益，您即购买高德黑卡商家服务的经营者委托深圳市德友惠信息技术有限公司（以下简称“我方”或“德友惠”）为您提供高德黑卡商家权益托管服务，即在您黑卡商家服务存续期间您委托我方根据您所购买并享有的黑卡商家权益进行管理，为此您知悉并同意不可撤销地向我方授权如下事宜：
      </p>
      <p></p>
      <ol style="margin-bottom: 8px; list-style: none">
        <li>
          您授权德友惠以您的名义与高德黑卡服务提供商高德地图联系并沟通您的产品在高德地图上的呈现相关事宜。包括并不仅限于：门店内容的正确呈现、展示，在高德地图上的合理推介等。
        </li>
      </ol>
      <p></p>
      <ol start="2" style="margin-bottom: 8px; list-style: none">
        <li>
          您授权德友惠以您的本人名义与高德黑卡服务提供商高德地图联系并沟通与您门店有关的服务、技术实现等诸事项。包括并不限于：以您的名义与高德地图就相关产品技术问题、流程问题、质量问题等的意见交换、问题解决。
        </li>
      </ol>
      <p></p>
      <ol start="3" style="margin-bottom: 8px; list-style: none">
        <li>
          您授权德友惠以您的本人名义与且高德黑卡服务服务提供商高德地图对接实现所有信息的即时交互、同步、更新、反馈、共享等一切必要的信息使用或发布。如您提供给德友惠服务人员您的账户信息（包含账号、登录密码等）即视为本条特别授权的同意行为。
        </li>
      </ol>
      <p></p>
      <ol start="4" style="margin-bottom: 8px; list-style: none">
        <li>
          您授权德友惠为您提供商品/服务上架以及资金账号管理，包括但不限于为您进行收款与后台对账服务等。如您提供给德友惠服务人员您的账户信息（包含账号、登录密码等）即视为本条特别授权的同意行为。
        </li>
      </ol>
      <p></p>
      <ol start="5" style="margin-bottom: 8px; list-style: none">
        <li>
          当某特定事项下德友惠需要不同于前述内容的特别授权才能实行的特定行为时，德友惠服务人员会与您事前沟通，当您知悉并同意时即视为您已经对该行为事项进行了特别授权，而无需针对该行为事项进行其他形式的授权。
        </li>
      </ol>
      <p></p>
      <ol start="6" style="margin-bottom: 8px; list-style: none">
        <li>
          德友惠承诺在实施授权行为时应尽注意义务，不得超越授权范围，不得恶意增加您的负担或单方面减损您的权利。您知悉并认可德友惠在您的授权下实施的行为其法律后果均将归属您本人承受。
        </li>
      </ol>
      <p></p>
      <p></p>
      <p>
        <strong
          ><u
            >如您点选确认“同意协议内容”，即视为您已阅读并同意本《黑卡商家服务托管协议》（以下简称“本协议”），自愿接受本协议的所有内容的约束。请您在决定使用本服务前再次确认您已知悉并完全理解本协议的所有内容。</u
          ></strong
        >
      </p>
    </section>
  </div>
</template>
<script lang="ts">
import { Vue, Component } from 'vue-property-decorator';

@Component({})
export default class PolicyEscrow extends Vue {}
</script>

<style lang="scss" scoped>
.wrap {
  padding: 20px 15px;
}
</style>
